import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { passageirosModuleName, passageirosStorage } from "../shared/data.service";
import { Passageiro } from "../shared/passageiro.model";
import { editRoute, configuracaoModuleName, newRoute } from "../../../shared/services/data.service";
import { PassageiroNavigationService } from "../shared/passageiro-navigation.service";
import { PassageiroApiService } from "../shared/passageiro-api.service";
import { PhoneValidator } from "../../../shared/validators/phone.validation";
import { EmailValidator } from "../../../shared/validators/email.validation";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { PassageiroService } from "../shared/passageiro.service";
import { CpfValidator } from "../../../shared/validators/cpf.validation";
import { Endereco } from "../../../estruturas/enderecos/shared/endereco.model";
import { EnderecoService } from "../../../estruturas/enderecos/shared/endereco.service";
import { viagensModuleName } from "../../shared/data.service";
import { ViagemService } from "../../shared/viagem.service";

@Component({
    template: require('./passageiro-form.component.html'),
    styles: [require('./passageiro-form.component.css')]
})
export class PassageiroFormComponent implements OnInit {
    passageirosModule: any = passageirosModuleName;
    formObject: Passageiro = new Passageiro();
    formObjectToSave: any = new Passageiro();
    enderecoObject: any = new Endereco();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    configuracaoModule: any = configuracaoModuleName;
    module: any = viagensModuleName;

    form: FormGroup;
    nome = new FormControl('', Validators.required);
    dataNascimento = new FormControl('');
    ativo = new FormControl('');
    email = new FormControl('', Validators.compose([EmailValidator.emailFormat]));
    rg = new FormControl('');
    rgOrgaoExpedidor = new FormControl('');
    telefone = new FormControl('', Validators.compose([PhoneValidator.phoneFormat]));
    cpf = new FormControl('', Validators.compose([CpfValidator.cpfFormat]));

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responsePassageiro: any;

    constructor(
        private _route: ActivatedRoute,
        private _passageiroNavigationService: PassageiroNavigationService,
        private _passageiroApiService: PassageiroApiService,
        private _enderecoService: EnderecoService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _passageiroService: PassageiroService,
        private _viagemService: ViagemService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            email: this.email,
            nome: this.nome,
            dataNascimento: this.dataNascimento,
            rg: this.rg,
            rgOrgaoExpedidor: this.rgOrgaoExpedidor,
            telefone: this.telefone,
            cpf: this.cpf
        });
    }

    ngOnInit() {
        let id = +this._route.snapshot.params['id'];

        if (id) {
            this.actionTitle = editRoute;
            this.getObject(id);
        } else {
            this.actionTitle = newRoute;
            this.isNewAutoComplete();
        }
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickGoToConfig() {
        this._viagemService.goToSetting()
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:Passageiro = this._utilService.cloneObject(this.formObject);

            if (object.telefone) {
                object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
            }

            if (object.cpf) {
                object.cpf = this._utilService.removeSpecialCharacter(object.cpf);
            }

            let date: any = document.getElementById('dataNascimento');
            if (date.value) {
                object.dataNascimento = this._utilService.convertStringToDate(date.value);
            }

            this.formObjectToSave = object;
            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
        }
    }

    private onDoneEndereco = (function (Response: any) {
        if (!Response.error)  {
            this.formObjectToSave.enderecoId = Response.id;
            if (this.formObject.id) {
                this.onEditPassageiro();
            } else {
                this.onAddPassageiro();
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private onAddPassageiro() {
       this._passageiroApiService.onPost(this.formObjectToSave, this.onDone);
    }

    private onEditPassageiro() {
        this._passageiroApiService.onPut(this.formObjectToSave, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responsePassageiro = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                if (Response.dataNascimento) {
                    Response.dataNascimento = this._utilService.convertDateToString(Response.dataNascimento);
                }
                this.formObject = Response;
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum passageiro encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._passageiroApiService.onGetById(id, onDone);
    }

    private isNewAutoComplete() {
        const newAutoComplete: any = this._autocompleteService.getSessionStorage(passageirosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.nome = newAutoComplete.nome;
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._passageiroService.returnToOtherForm(this.otherForm, this.responsePassageiro);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._passageiroNavigationService.goToList();
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/passageiro-form/passageiro-form.component.ts
 **/